/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { whatsAppEmbeddedSignupStatus } from '../../axios/whatsAppEmbeddedSignupStatus'
import type {
	WhatsAppEmbeddedSignupStatusError,
	WhatsAppEmbeddedSignupStatusPathParams,
	WhatsAppEmbeddedSignupStatusResponse,
} from '../../types/WhatsAppEmbeddedSignupStatus'

export const whatsAppEmbeddedSignupStatusQueryKey = (
	organisationId: WhatsAppEmbeddedSignupStatusPathParams['organisationId'],
) => [{ url: '/organisations/:organisationId/whatsapp-account/signup/status', params: { organisationId } }] as const

export type WhatsAppEmbeddedSignupStatusQueryKey = ReturnType<typeof whatsAppEmbeddedSignupStatusQueryKey>

/** @see backend/nexus/modules/Campaign/Http/Controllers/WhatsAppEmbeddedSignupController.php WhatsAppEmbeddedSignupController::status */
export function whatsAppEmbeddedSignupStatusQueryOptions(
	organisationId: WhatsAppEmbeddedSignupStatusPathParams['organisationId'],
	config?: AxiosRequestConfig,
) {
	return queryOptions<
		WhatsAppEmbeddedSignupStatusResponse,
		AxiosError<WhatsAppEmbeddedSignupStatusError>,
		WhatsAppEmbeddedSignupStatusResponse,
		WhatsAppEmbeddedSignupStatusQueryKey
	>({
		queryKey: whatsAppEmbeddedSignupStatusQueryKey(organisationId),
		queryFn: ({ signal }) =>
			whatsAppEmbeddedSignupStatus(organisationId, { signal, ...config }).then(res => res.data),
		enabled: !!organisationId,
	})
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/WhatsAppEmbeddedSignupController.php WhatsAppEmbeddedSignupController::status */
export function useWhatsAppEmbeddedSignupStatus<TSelectData = WhatsAppEmbeddedSignupStatusResponse>(
	organisationId: WhatsAppEmbeddedSignupStatusPathParams['organisationId'],
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					WhatsAppEmbeddedSignupStatusResponse,
					AxiosError<WhatsAppEmbeddedSignupStatusError>,
					TSelectData,
					WhatsAppEmbeddedSignupStatusQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<WhatsAppEmbeddedSignupStatusError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...whatsAppEmbeddedSignupStatusQueryOptions(organisationId),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/WhatsAppEmbeddedSignupController.php WhatsAppEmbeddedSignupController::status */
export function useWhatsAppEmbeddedSignupStatusSuspense<TSelectData = WhatsAppEmbeddedSignupStatusResponse>(
	organisationId: WhatsAppEmbeddedSignupStatusPathParams['organisationId'],
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					WhatsAppEmbeddedSignupStatusResponse,
					AxiosError<WhatsAppEmbeddedSignupStatusError>,
					TSelectData,
					WhatsAppEmbeddedSignupStatusQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<WhatsAppEmbeddedSignupStatusError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...whatsAppEmbeddedSignupStatusQueryOptions(organisationId),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
